module.exports = __webpack_public_path__ + "img/service5.3606bb71.png";